<template>
  <BaseCustomizeMetal componentCode="AQ" />
</template>

<script>
import BaseCustomizeMetal from "@/components/customizeMetal/traditionalMetal/BaseCustomizeMetal/index.vue";
export default {
  name: "CustomizeMetalAQ",
  components: {
    BaseCustomizeMetal,
  },
};
</script>

<style scoped lang="scss">
::v-deep {
  .metal-text {
    top: 68px;
    left: 111px;
    @include betweenTableTablePro {
      top: 32px;
      left: 61px;
    }
    @include table {
      top: 14px;
      left: 36px;
    }
    @include phone {
      top: 9px;
      left: 21px;
    }
  }
  .templeName {
    height: 28px;
    width: 203px;
    .textContainer {
      width: 235px;
    }
  }
  .godName {
    width: 279px;
    height: 72px;
    .textContainer {
      width: 279px;
    }
  }
  .gift {
    width: 171px;
    height: 39px;
    .textContainer {
      width: 171px;
    }
  }
}
</style>
